import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { KpiResult } from '@masar/common/models';
import {
    formatKpiDurationValue,
    formatKpiFixedNumber,
} from '@masar/common/utils';

@Pipe({
    name: 'formatKpiResult',
    standalone: false,
})
export class FormatKpiResultPipe implements PipeTransform {
    public constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

    public transform(
        value: number,
        units: KpiResult['units'],
        unitDescription: string,
        applyThousandSeparator: boolean = false,
        decimalPlaces: number = 2
    ): string {
        if (value === null || value === undefined) return value as any;

        switch (units) {
            case 'currency':
                return `${formatKpiFixedNumber(value, decimalPlaces, {
                    locale: this.locale,
                    thousandSeparator: true,
                })} ${unitDescription}`;
            case 'time':
                return `${formatKpiFixedNumber(value, decimalPlaces, {
                    locale: this.locale,
                })} ${unitDescription}`;
            case 'percentage':
                return `${formatKpiFixedNumber(value, decimalPlaces, {
                    locale: this.locale,
                    trimTrailingZeros: true,
                })}%`;
            case 'minute':
                return formatKpiDurationValue(value, 'minute');
            case 'hour':
                return formatKpiDurationValue(value, 'hour');
            default:
                return formatKpiFixedNumber(value, decimalPlaces, {
                    locale: this.locale,
                    thousandSeparator: applyThousandSeparator,
                    trimTrailingZeros: true,
                });
        }
    }
}
